import { applyFolderAsOperationFr } from "@Front/Utils/applyFolderAsOperationFr";
import { peekPublicUiOptions } from "@Front/Services/PublicSiteConfig/publicSiteConfigLoader";
import { workspaceNounLower, workspaceSubject } from "@Front/Utils/publicSiteBranding";

export function buildAskDocumentsWrongOfficeMessage(): string {
	if (peekPublicUiOptions().uses_estate_workspace_terms_in_ui_copy) {
		return applyFolderAsOperationFr(
			"Ce dossier appartient à une autre étude. Sélectionnez l'office correspondant pour pouvoir envoyer une demande de documents.",
		);
	}
	const nounLower = workspaceNounLower();
	return applyFolderAsOperationFr(
		`Ce dossier appartient à un autre ${nounLower}. Sélectionnez ${workspaceSubject()} correspondant pour pouvoir envoyer une demande de documents.`,
	);
}

export function buildCreateFolderNoActiveOfficeErrorMessage(): string {
	if (peekPublicUiOptions().uses_estate_workspace_terms_in_ui_copy) {
		return applyFolderAsOperationFr(
			"Aucune étude active n'a été détectée. Sélectionnez une étude dans l'en-tête avant de créer un dossier.",
		);
	}
	const nounLower = workspaceNounLower();
	return applyFolderAsOperationFr(
		`Aucun ${nounLower} actif n'a été détecté. Sélectionnez un ${nounLower} dans l'en-tête avant de créer un dossier.`,
	);
}
